const DEFAULT = 'Taxas do financiamento';

function description(expense) {
  if (expense.payload && expense.payload.description) {
    return expense.payload.description;
  }

  if (expense.description) {
    return expense.description;
  }

  return DEFAULT;
}

function codes(expense, code) {
  switch (code) {
    case '8':
    case 'contract_record_rate':
      return 'Tarifa de registro do contrato';
    case '6':
    case 'register_rate':
      return 'Tarifa de abertura de crédito';
    case '23':
    case 'property_valuation_rate':
      return 'Tarifa de avaliação de bens';
    case 'iof_value':
      return 'IOF';
    case 'spf':
      return 'Seguro de proteção financeira';
    case 'cap':
      return 'Título de capitalização';
    case 'bem':
      return 'Seguro do bem';
    case 'personal_insurance':
      return 'Seguro de acidentes pessoais';
    case 'warranty':
      return 'Garantia';
    default:
      return description(expense);
  }
}

export default function identify(expense = {}) {
  if (expense.credere_type) {
    return codes(expense, expense.credere_type);
  }

  if (expense.payload && expense.payload.credere_type) {
    return codes(expense, expense.payload.credere_type);
  }

  return codes(expense, expense.type);
}
